import React from 'react';

export default function FinanceNav({ activeView, setFinanceView }) {
    const NavButton = ({ viewName, children }) => {
        const isActive = activeView === viewName;
        return (
            <button
                onClick={() => setFinanceView(viewName)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition ${
                    isActive ? 'bg-[#213368] text-white' : 'bg-white text-gray-600 hover:bg-gray-100'
                }`}
            >
                {children}
            </button>
        );
    };

    return (
        <div className="bg-white p-2 rounded-lg shadow-sm border flex items-center space-x-2">
            <NavButton viewName="dashboard">Dashboard</NavButton>
            <NavButton viewName="vendors">Vendor Management</NavButton>
            <NavButton viewName="payments">Payment Center</NavButton>
            {/* --- NEW: Button for the Purchase Center --- */}
            <NavButton viewName="purchases">Purchase Center</NavButton>
	    {/* --- NEW: Button for the Expense Center --- */}
            <NavButton viewName="expenses">Expense Center</NavButton>
        </div>
    );
}